import styled, {css} from 'styled-components'

export const StyledRowWarningTooltip = styled.div(
    ({theme: {typography, palette, spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        ${typography.textSm};

        & > svg {
            fill: ${palette.orange['500']};
        }
        & p {
            color: ${palette.neutral['500']};
            font-weight: 400;
        }
        & a {
            text-decoration: underline;
            cursor: pointer;
        }
    `
)
